import React from 'react';

import { VpPluginSwitchSection } from './VpPluginSwitchSection';
import { VpPluginDateSubmittedInputs } from '../..';

export const VpPluginDateSubmittedSection = () => {
  return (
    <VpPluginSwitchSection name="showSubmissionDate" label="DATE SUBMITTED">
      <VpPluginDateSubmittedInputs />
    </VpPluginSwitchSection>
  );
};

export default VpPluginDateSubmittedSection;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/VpPluginDateSubmittedSection.jsx